/**
 * Print HTML String to plain HTML Element
 * @param {*} text String to be converted
 */
export function filter_gutenberg_blocks(gutenberg) {
  let filtered_blocks = gutenberg.filter((block) => block.blockName !== null);
  const blocks = [];
  let latest_is_core = false;

  for (const block of filtered_blocks) {
    const { blockName, attrs } = block;

    if (blockName === "core/gallery") {
      block.blockName = "nan/gallery";
    }
    if (blockName === "core/quote") {
      block.blockName = "nan/quote";
    }

    const is_core_block = block.blockName.startsWith("core/");
    if (is_core_block) {
      if (!latest_is_core) {
        const containerBlock = {
          blockName: "core/container",
          innerBlocks: [],
        };
        blocks.push(containerBlock);
      }

      if (block?.blockName == "core/video") {
        const get_video_url = block?.innerHTML?.match(/src="([^"]+)"/)[1];
        const block_data = {
          blockName: block?.blockName,
          attrs: block?.attrs,
          innerHTML: `<div class='video-container'><video controls><source src=${get_video_url}></video></div>`,
        };
        blocks[blocks.length - 1].innerBlocks.push(block_data);
      } else if (block?.blockName == "nan/gallery") {
        const galleryBlock = {
          blockName: "nan/gallery",
          attrs: block.attrs,
          innerBlocks: block.innerBlocks || [],
        };
        blocks[blocks.length - 1].innerBlocks.push(galleryBlock);
      } else {
        blocks[blocks?.length - 1].innerBlocks.push(block);
      }
    } else {
      blocks.push(block);
    }
    latest_is_core = is_core_block;
  }

  // Ensure the first core/container block is marked as is_first
  if (blocks.length > 0) {
    const firstCoreContainer = blocks.find((block) => block?.blockName === "core/container");
    if (firstCoreContainer) {
      firstCoreContainer.is_first = true;
    }
  }

  return blocks;
}
